/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Security_DepositInputs */

const cs_enum_security_deposit = /** @type {(inputs: Enum_Security_DepositInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jistota`)
};

const en_enum_security_deposit = /** @type {(inputs: Enum_Security_DepositInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Security deposit`)
};

/**
* | output |
* | --- |
* | "Security deposit" |
*
* @param {Enum_Security_DepositInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_security_deposit = /** @type {((inputs?: Enum_Security_DepositInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Security_DepositInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_security_deposit(inputs)
	return cs_enum_security_deposit(inputs)
});